





import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class RichTextDisplay extends Vue {
  @Prop() public vHtml!: string;
}
